// 보고서 뷰어 도메인 관련 공통 유틸
// 현재 페이지 도메인을 우선 사용하고, 사용 불가 / 오류 발생 시 canonical production URL로 fallback.
// 환경별(dev/staging/prod) 동일 코드로 동작하도록 보장.

const FALLBACK_VIEWER_ORIGIN = 'https://report.qesg.co.kr';

/**
 * 현재 페이지의 origin (예: 'https://staging.report.qesg.co.kr') 또는 fallback.
 * - SSR/Node 환경, file://, 보안 정책 차단 등으로 window.location.origin 접근이 불가하면 fallback.
 * - origin이 http(s) 스킴이 아니면 fallback.
 *
 * @returns {string} origin (끝에 '/' 없음)
 */
export function getViewerBaseUrl() {
  try {
    if (typeof window !== 'undefined' && window.location && window.location.origin) {
      const origin = window.location.origin;
      if (/^https?:\/\//.test(origin)) return origin;
    }
  } catch (e) {
    // ignore
  }
  return FALLBACK_VIEWER_ORIGIN;
}
